document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-mobile-menu-trigger]');
  var menu = document.querySelector('[data-mobile-menu]');

  if (!trigger || !menu) return;

  var isOpen = menu.hasAttribute('data-open');
  if (isOpen) {
    menu.removeAttribute('data-open');
    trigger.setAttribute('aria-expanded', 'false');
  } else {
    menu.setAttribute('data-open', '');
    trigger.setAttribute('aria-expanded', 'true');
  }
});
